import React from 'react';
interface Node {
  id: string;
  x: number;
  y: number;
  label: string;
  status: 'complete' | 'running' | 'pending' | 'attention';
}
interface Connection {
  from: string;
  to: string;
}
const nodes: Node[] = [{
  id: '1',
  x: 50,
  y: 150,
  label: 'Start',
  status: 'complete'
}, {
  id: '2',
  x: 180,
  y: 80,
  label: 'Research',
  status: 'complete'
}, {
  id: '3',
  x: 180,
  y: 220,
  label: 'Design',
  status: 'complete'
}, {
  id: '4',
  x: 320,
  y: 80,
  label: 'Implement',
  status: 'running'
}, {
  id: '5',
  x: 320,
  y: 220,
  label: 'Review',
  status: 'pending'
}, {
  id: '6',
  x: 460,
  y: 150,
  label: 'Deploy',
  status: 'pending'
}];
const connections: Connection[] = [{
  from: '1',
  to: '2'
}, {
  from: '1',
  to: '3'
}, {
  from: '2',
  to: '4'
}, {
  from: '3',
  to: '5'
}, {
  from: '4',
  to: '6'
}, {
  from: '5',
  to: '6'
}];
const statusColors = {
  complete: {
    fill: '#10b981',
    stroke: '#059669',
    glow: 'rgba(16, 185, 129, 0.4)'
  },
  running: {
    fill: '#3b82f6',
    stroke: '#2563eb',
    glow: 'rgba(59, 130, 246, 0.5)'
  },
  pending: {
    fill: '#4b5563',
    stroke: '#374151',
    glow: 'transparent'
  },
  attention: {
    fill: '#f59e0b',
    stroke: '#d97706',
    glow: 'rgba(245, 158, 11, 0.4)'
  }
};
export function NodeVisualization() {
  const getNodePosition = (id: string) => {
    const node = nodes.find(n => n.id === id);
    return node ? {
      x: node.x,
      y: node.y
    } : {
      x: 0,
      y: 0
    };
  };
  return <div className="relative w-full h-full">
      <svg viewBox="0 0 520 300" className="w-full h-full" style={{
      filter: 'drop-shadow(0 0 40px rgba(59, 130, 246, 0.15))'
    }}>
        <defs>
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="3" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#8b5cf6" stopOpacity="0.6" />
          </linearGradient>
        </defs>

        {/* Connection lines */}
        {connections.map((conn, i) => {
        const from = getNodePosition(conn.from);
        const to = getNodePosition(conn.to);
        const midX = (from.x + to.x) / 2;
        return <path key={i} d={`M ${from.x} ${from.y} Q ${midX} ${from.y} ${midX} ${(from.y + to.y) / 2} Q ${midX} ${to.y} ${to.x} ${to.y}`} fill="none" stroke="url(#lineGradient)" strokeWidth="2" strokeDasharray="4 4" className="animate-pulse-slow" />;
      })}

        {/* Nodes */}
        {nodes.map(node => {
        const colors = statusColors[node.status];
        return <g key={node.id} className={node.status === 'running' ? 'animate-pulse' : ''}>
              {/* Glow effect */}
              <circle cx={node.x} cy={node.y} r="28" fill={colors.glow} filter="url(#glow)" />
              {/* Node circle */}
              <circle cx={node.x} cy={node.y} r="22" fill={colors.fill} stroke={colors.stroke} strokeWidth="2" />
              {/* Label */}
              <text x={node.x} y={node.y + 4} textAnchor="middle" fill="white" fontSize="10" fontWeight="500" fontFamily="Inter, sans-serif">
                {node.label}
              </text>
            </g>;
      })}
      </svg>
    </div>;
}